import React from "react";
import UserProfile from "components/UserProfile/UserProfile";
import { useEffect, useState } from "react";
import API from "components/Apis/API";
import toast, { Toaster } from 'react-hot-toast';
import { useLocation } from 'react-router-dom'
import $ from 'jquery';


// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col
} from "react-bootstrap";

const User = () => {
  const [userData, setUserData] = useState([])
  const [apiKey, setApiKey] = useState("")

  const fetchData = async () => {
    const toastId = toast.loading("Loading user profile...");
    const url   = await ""+"admin/get_profile";
    const token = await UserProfile.getToken();
    const response = await API.getData(url)
    const data = response
    if(data.status)
    {
      setUserData(data.data);
      toast.dismiss(toastId);
    }
    else
    {
      toast.dismiss(toastId);
    }
  }

  const getApiKey = async () => {
    const toastId = toast.loading("Generating token for 365 days...");
    const url   = await ""+"admin/user/permanent_token";
    const response = await API.getData(url)
    const data = response
    if(data.status)
    {
      setApiKey(data.data.token);
      toast.dismiss(toastId);
    }
    else
    {
      toast.dismiss(toastId);
    }
  }
  const updateUser = async() =>
  {
    event.preventDefault();
    const toastId = toast.loading("Updating user profile...");
    const url     = await ""+"admin/update_profile";
    const token   = await UserProfile.getToken();
    const formData = new FormData($('.userData')[0]);
    console.log(formData);
    const response = await API.postData(url, formData)
    const rsp = response
    if(rsp.status)
    {
      toast.dismiss(toastId);
      toast.success(rsp.msg);
    }
    else
    {
      toast.dismiss(toastId);
      toast.error("Failed to update records!");
    }
  }
  useEffect(() => {
    fetchData()
  }, []);

  return (
    <>
      <Toaster position="bottom-right" />
      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Edit Profile</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form className="userData">
                  <Row>
                    <Col className="pr-1" md="5">
                      <Form.Group>
                        <label>Login Method</label>
                        <Form.Control
                          defaultValue="Username and Password"
                          disabled
                          placeholder="Company"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="px-1" md="3">
                      <Form.Group>
                        <label>Username</label>
                        <Form.Control
                          defaultValue={userData.username}
                          placeholder="Username"
                          type="text"
                          disabled
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pl-1" md="4">
                      <Form.Group>
                        <label htmlFor="exampleInputEmail1">
                          Email address
                        </label>
                        <Form.Control
                          placeholder="Email"
                          defaultValue={userData.email}
                          type="email"
                          disabled
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-1" md="6">
                      <Form.Group>
                        <label>First Name</label>
                        <Form.Control
                          defaultValue={userData.first_name}
                          placeholder="First Name"
                          name="first_name"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pl-1" md="6">
                      <Form.Group>
                        <label>Last Name</label>
                        <Form.Control
                          defaultValue={userData.last_name}
                          placeholder="Last Name"
                          type="text"
                          name="last_name"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <hr></hr>
                      <p style={{color:"red"}}>* Leave it empty if you do not want to change your password</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4">
                      <Form.Group>
                        <label>Old Password</label>
                        <Form.Control
                          defaultValue=""
                          placeholder="Old password"
                          type="password"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pr-1" md="4">
                      <Form.Group>
                        <label>New Password</label>
                        <Form.Control
                          defaultValue=""
                          placeholder="New password"
                          type="password"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="px-1" md="4">
                      <Form.Group>
                        <label>Confirm Passowrd</label>
                        <Form.Control
                          defaultValue=""
                          placeholder="Confirm password"
                          type="password"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>

                  <hr></hr>
                  <Button
                    className="btn btn-primary pull-right"
                    type="submit"
                    variant="info"
                    onClick={()=>updateUser()}
                  >
                    Update Profile
                  </Button>
                  <Button
                    className="btn btn-success pull-right"
                    type="button"
                    variant="info"
                    onClick={()=>getApiKey()}
                  >
                    Get API Key (for developers only)
                  </Button>
                  <br></br>
                 
                  <div className="clearfix"></div>
                </Form>
                <code>{apiKey}</code>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>)

}

export default User;
